export default __webpack_public_path__ + "static/media/arrow_left_filled.7ab41d5c.svg";